











import Vue from "vue";
import { setLocale } from "@isocial-vue/blueprint";
import Logout from "./Logout.vue";

export default Vue.extend({
  beforeMount() {
    // Default locale => NL
    if (this.$i18n.locale === "en") setLocale("nl");
  },
  components: {
    Logout,
  },
  computed: {
    actions() {
      return [
        {
          label: this.$t("rtwp.logout.button"),
          icon: "fa-sign-out-alt",
          action: () => {
            const logout = new Event("onLogout");
            document.dispatchEvent(logout);
          },
        },
      ];
    },
  },
  // eslint-disable-next-line
  errorCaptured(err: any, vm: any, info: any) {
    // FIXME: what should this be exactly?
    this.$snackbar.show(err.toString(), [{ label: "close", value: "" }], { error: true });
    return false;
  },
});
